import { useEffect, useState } from "react";

import Hero from "./Hero/Hero";
import Market from "Pages/Home/Market/Market";
import MarketMobile from "Pages/Home/Market/MarketMobile";

// fetching data
import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";

import IsError from "Components/RequestHandler/IsError";
import { useParams } from "react-router-dom";
const SegmentDetailed = () => {
  const { slug } = useParams();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`getmarketsegments/${slug}`);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [slug]);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero data={data} />
        <Market data={data?.segments} />
        <div className="mb-secondary">
          <MarketMobile data={data?.segments} />
        </div>
      </main>
    );
  }
};

export default SegmentDetailed;
